import { getSmsMetrics } from '@/services/dashboard-service/dashboard.service';
import { DashboardFilters } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useSmsMetric = (params: DashboardFilters, isCompanyAdmin?: boolean) => {
  const {
    data: smsMetricData,
    error,
    isPending,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.SMS_METRICS(params),
    queryFn: () => getSmsMetrics(params),
    enabled: isCompanyAdmin || !!params.company_name,
  });
  return { smsMetricData, error, isPending, refetch };
};
